import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const USER_EMAIL_NOTIFICATION_PREFERENCES = gql(`
  query userEmailNotificationPreferences {
    me {
      __typename
      id
      preferences {
        __typename
        emailNotifications {
          __typename
          MarketingDisabled
          ReleaseNotesDisabled
          OnboardingDisabled
          OrganizationUpdatesDisabled
          DeploymentUpdatesDisabled
        }
      }
    }
  }
`);

export function useUserEmailNotificationPreferences() {
  const { data, ...rest } = useQuery(USER_EMAIL_NOTIFICATION_PREFERENCES);

  const emailNotificationPreferences = data?.me.preferences.emailNotifications;

  return { ...rest, data: emailNotificationPreferences };
}
